import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetSubvouchersParams, GetSubvouchersResponse } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const getSubvouchers = createAsyncThunk<
  GetSubvouchersResponse,
  GetSubvouchersParams
>(
  `vouchers/getSubvouchers`,
  async ({ voucherId, ...params }, { rejectWithValue }) => {
    try {
      const data = await VouchersAPI.getSubvouchers({ voucherId, ...params });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting subvouchers",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting subvouchers", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);